import { resolveUrl } from "@/lib/api";

// Resolve once every card image (banner/photo + logo) is loaded, or after a timeout.
export const preloadImages = (businesses, timeout = 4000) => {
  const urls = businesses.flatMap((b) => [b.cover_image || b.photos?.[0], b.logo]).filter(Boolean).map(resolveUrl);
  const loads = urls.map((src) => new Promise((done) => {
    const img = new Image();
    img.onload = img.onerror = done;
    img.src = src;
  }));
  return Promise.race([Promise.all(loads), new Promise((r) => setTimeout(r, timeout))]);
};
